import loadable from "@loadable/component";
import { getLoading } from "@sprout/views";
export default loadable(()=>import("./ArchivePage" /* webpackChunkName: "ArchivePage" */ ), {
    fallback: getLoading()
});
